import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faBars,
  faFileContract, faFileInvoice,
  faFileInvoiceDollar, faHandsHelping,
  faInfoCircle, faMessage,
  faMoneyBills,
  faPlugCircleBolt,
  faTags,
  faUpload,
  faUser,
  faUsers
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useProfile } from "../../context/ProfileContext";
import { ReactComponent as TelegramIcon } from "../../telegram.svg";
import { Spliter } from "./spliter";

type MenuProps = {} & React.HTMLAttributes<HTMLDivElement>;

export function Menu({ children, ...props }: MenuProps) {
  const { profile, roles } = useProfile();
  let isOpenStorage;
  try {
    isOpenStorage = localStorage.getItem("menu:isOpen") === "true"
  } catch (e) {
    console.error("Error reading menu:isOpen from localStorage:", e);
    isOpenStorage = false; // Default to closed if there's an error
  }
  const [isOpen, setIsOpen] = useState(isOpenStorage);
  const [isAdmin, setIsAdmin] = useState<Boolean>(false);
  const [isHead, setIsHead] = useState<Boolean>(false);
  const location = useLocation();

  const toggleDrawer = () => setIsOpen(!isOpen);
  const closeDrawer = (toPage: string) => () => {
    if (location.pathname !== toPage && toPage !== "") {
      try {
        localStorage.setItem("page", toPage);
      } catch (e) {
        console.error("Error saving page to localStorage:", e);
      }
    }
    isOpen && setIsOpen(!isOpen)
  };
  const openDrawer = () => !isOpen && setIsOpen(!isOpen);
  const handleMouseLeave = () => isOpen && setIsOpen(false);

  useEffect(() => {
    if (roles && roles.includes("ADMIN")) {
      setIsAdmin(true);
    }
    if (roles && roles.includes("HEAD")) {
      setIsHead(true);
    }
  }, []);

  useEffect(() => {
    if (roles && roles.includes("ADMIN")) {
      setIsAdmin(true);
    }
    if (roles && roles.includes("HEAD")) {
      setIsHead(true);
    }
  }, [roles]);

  useEffect(() => {
    try {
      localStorage.setItem("menu:isOpen", isOpen.toString());
    } catch (e) {
      console.error("Error saving menu:isOpen to localStorage:", e);
    }
  }, [isOpen]);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-col bg-gradient-to-b from-blue-50 to-purple-100" {...props}>
        {/* Drawer Background */}
        <div
          className={`fixed inset-0 bg-black opacity-50 z-40 ${isOpen ? "flex" : "hidden"}`}
          onClick={toggleDrawer}
        ></div>
        {/* Menu bar */}
        <div
          className={`flex flex-col fixed left-0 top-0 h-full bg-gray-800 text-white transform transition-transform duration-1300 ease-in-out z-40 ${
            isOpen ? "translate-x-0 w-48" : "translate-x-0 w-9"
          }`}
          onMouseEnter={openDrawer}
          onMouseLeave={handleMouseLeave}
        >
          <div className="flex justify-between items-center p-1">
            <button onClick={toggleDrawer} className="text-white">
              {isOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <FontAwesomeIcon icon={faBars} className={"ml-1"} color="white"/>
              )}
            </button>
          </div>
          <Link to={"/message"} className={"p-2 " + (location.pathname === '/message' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/message")}>
            <FontAwesomeIcon icon={faMessage}/><span className={isOpen ? "" : "hidden"}> Сповіщення</span></Link>
          <Link to={"/requisite"} className={"p-2 " + (location.pathname === '/requisite' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/requisite")}>
            <FontAwesomeIcon icon={faFileInvoice}/><span className={isOpen ? "" : "hidden"}> Реквізити</span></Link>
          <Link to={"/profile"} className={"p-2 " + (location.pathname === '/profile' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/profile")}>
            <FontAwesomeIcon icon={faUser}/><span className={isOpen ? "" : "hidden"}> Садівник</span></Link>
          <Link to={"/tariffs"} className={"p-2 " + (location.pathname === '/tariffs' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/tariffs")}>
            <FontAwesomeIcon icon={faTags}/><span className={isOpen ? "" : "hidden"}> Тарифи</span>
          </Link>
          <Link to={"/bills"} className={"p-2 " + (location.pathname === '/bills' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/bills")}>
            <FontAwesomeIcon icon={faMoneyBills}/><span className={isOpen ? "" : "hidden"}> Рахунки</span>
          </Link>
          <Link to={"/power"} className={"p-2 " + (location.pathname === '/power' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/power")}>
            <FontAwesomeIcon icon={faPlugCircleBolt}/><span className={isOpen ? "" : "hidden"}> Електроенергія</span>
          </Link>
          <Link to={"/debts"} className={"p-2 " + (location.pathname === '/debts' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/debts")}>
            <FontAwesomeIcon icon={faFileContract}/><span className={isOpen ? "" : "hidden"}> Борги</span>
          </Link>
          <Link to={"/membership"} className={"p-2 " + (location.pathname === '/membership' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/membership")}>
            <FontAwesomeIcon icon={faFileInvoiceDollar}/><span className={isOpen ? "" : "hidden"}> Членські</span>
          </Link>
          <Link to={"/target"} className={"p-2 " + (location.pathname === '/target' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/target")}>
            <FontAwesomeIcon icon={faFileInvoiceDollar}/><span
            className={isOpen ? "" : "hidden"}> Цільові платежі</span>
          </Link>
          <Link to={"/telegram"}
                className={`p-2 ${isOpen ? "flex justify-start items-center" : "pb-2.5 pt-2.5"}` + (location.pathname === '/telegram' ? "bg-blue-300" : "")}
                onClick={closeDrawer("/telegram")}>
            <TelegramIcon height="20" className={"mr-0.5"}/>
            <span className={isOpen ? "" : "hidden"}> Telegram бот</span>
          </Link>
          {(isAdmin || isHead) && (
            <>
              <Spliter/>
              <Link to={"/users"} className={"p-2 " + (location.pathname === '/users' ? "bg-blue-300" : "")}
                    onClick={closeDrawer("")}>
                <FontAwesomeIcon icon={faUsers}/><span className={isOpen ? "" : "hidden"}> Користувачі</span>
              </Link>
            </>
          )}
          {(isAdmin) && (
            <>
              <Spliter/>
              <Link to={"/manage/help"} className={"p-2 " + (location.pathname === '/manage/help' ? "bg-blue-300" : "")}
                    onClick={closeDrawer("/manage/help")}>
                <FontAwesomeIcon icon={faHandsHelping}/><span className={isOpen ? "" : "hidden"}> Допомога (ред.)</span></Link>
              <Link to={"/manage/message"} className={"p-2 " + (location.pathname === '/manage/message' ? "bg-blue-300" : "")}
                    onClick={closeDrawer("/manage/message")}>
                <FontAwesomeIcon icon={faMessage}/><span className={isOpen ? "" : "hidden"}> Сповіщення (ред.)</span></Link>
              <Link to={"/manage/requisite"} className={"p-2 " + (location.pathname === '/manage/requisite' ? "bg-blue-300" : "")}
                    onClick={closeDrawer("/manage/requisite")}>
                <FontAwesomeIcon icon={faFileInvoice}/><span className={isOpen ? "" : "hidden"}> Реквізити (ред.)</span></Link>
              <Link to={"/manage/telegram"} className={"p-2 flex justify-start items-center " + (isOpen ? "" : "mt-0.5 mb-0.5") + (location.pathname === '/manage/telegram' ? "bg-blue-300" : "")}
                    onClick={closeDrawer("/manage/telegram")}>
                <TelegramIcon height={isOpen ? "20" : "20"} className={""}/><span className={isOpen ? "" : "hidden"}> Telegram (ред.)</span></Link>
              <Link to={"/upload"} className={"p-2 " + (location.pathname === '/upload' ? "bg-blue-300" : "")}
                    onClick={closeDrawer("")}>
                <FontAwesomeIcon icon={faUpload}/><span className={isOpen ? "" : "hidden"}> Завантажити</span>
              </Link>
            </>
          )}
          <div className="flex flex-col mt-4">
            <Spliter/>
            <Link to={"/logout"} className={"p-2 " + (location.pathname === 'exit' ? "bg-blue-300" : "")}>
              <FontAwesomeIcon icon={faArrowRightFromBracket}/><span className={isOpen ? "" : "hidden"}> Вийти</span>
            </Link>
            <Link to={"/help"} className={"p-2 " + (location.pathname === 'help' ? "bg-blue-300" : "")}>
              <FontAwesomeIcon icon={faInfoCircle}/><span className={isOpen ? "" : "hidden"}> Допомога</span>
            </Link>
          </div>
        </div>
      </div>
      <div className="flex flex-col pl-10 pt-2">
        {children}
      </div>
    </div>
  );
}
